var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block container" }, [
    _c("div", { staticClass: "flex-item attention-state" }, [
      _vm.attention.status == "PENDING"
        ? _c("span", [
            _c("img", {
              staticClass: "icon icon-svg attention-state-item",
              attrs: {
                src: require("@/static/svg/icono_pendiente_v2.svg"),
                alt: "pendiente"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.attention.status == "COMPLETED"
        ? _c("span", [
            _c("img", {
              staticClass: "icon icon-svg attention-state-item",
              attrs: {
                src: require("@/static/svg/icono_check_v2.svg"),
                alt: "completado"
              }
            }),
            _vm._v(" "),
            _vm.attention.participationOf.evaluation == "MEH"
              ? _c("img", {
                  staticClass:
                    "icon icon-svg attention-state-item attention-evaluation",
                  attrs: {
                    src: require("@/static/svg/emoticon02.svg"),
                    alt: "Evaluación de participación"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.attention.participationOf.evaluation == "YAY"
              ? _c("img", {
                  staticClass:
                    "icon icon-svg attention-state-item attention-evaluation",
                  attrs: {
                    src: require("@/static/svg/emoticon01.svg"),
                    alt: "Evaluación de participación"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.attention.participationOf.evaluation == "SAD"
              ? _c("img", {
                  staticClass:
                    "icon icon-svg attention-state-item attention-evaluation",
                  attrs: {
                    src: require("@/static/svg/emoticon03.svg"),
                    alt: "Evaluación de participación"
                  }
                })
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.attention.status == "FAILED"
        ? _c("span", [
            _c("img", {
              staticClass: "icon icon-svg attention-state-item",
              attrs: {
                src: require("@/static/svg/icono_nocheck_v2.svg"),
                alt: "fallido"
              }
            }),
            _vm._v(" "),
            _vm.attention.participationOf.evaluation == "MEH"
              ? _c("img", {
                  staticClass:
                    "icon icon-svg attention-state-item attention-evaluation",
                  attrs: {
                    src: require("@/static/svg/emoticon02.svg"),
                    alt: "Evaluación de participación"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.attention.participationOf.evaluation == "YAY"
              ? _c("img", {
                  staticClass:
                    "icon icon-svg attention-state-item attention-evaluation",
                  attrs: {
                    src: require("@/static/svg/emoticon01.svg"),
                    alt: "Evaluación de participación"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.attention.participationOf.evaluation == "SAD"
              ? _c("img", {
                  staticClass:
                    "icon icon-svg attention-state-item attention-evaluation",
                  attrs: {
                    src: require("@/static/svg/emoticon03.svg"),
                    alt: "Evaluación de participación"
                  }
                })
              : _vm._e()
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex-item", staticStyle: { width: "91%" } }, [
      _c("div", { staticClass: "meta-list" }, [
        _c("div", { staticClass: "meta-item date" }, [
          _c("span", { staticClass: "meta-value" }, [
            _vm._v(_vm._s(_vm._f("formatStandardDate")(_vm.attention.dueBy)))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "meta-name", staticStyle: { "margin-bottom": "3px" } },
          [
            _c("span", { staticClass: "meta-value" }, [
              _c("strong", [_vm._v(_vm._s(_vm.attention.responsible.name))])
            ])
          ]
        ),
        _vm._v(" "),
        _vm.attention.status !== "PENDING"
          ? _c("div", [
              _vm.attention.participationOf &&
              _vm.attention.participationOf["comment"]
                ? _c("div", { staticClass: "meta-item comment" }, [
                    _c("span", { staticClass: "meta-value" }, [
                      _vm._v(_vm._s(_vm.attention.participationOf["comment"]))
                    ])
                  ])
                : _c("div", { staticClass: "comment" }, [
                    _c("span", { staticClass: "meta-value" }, [
                      _vm._v("Sin Comentario")
                    ])
                  ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "meta-item registerBy" }, [
          _c("span", [
            _vm._v(
              "\n          Registrado: " +
                _vm._s(_vm._f("formatStandardDate")(_vm.attention.createdAt)) +
                ",\n          " +
                _vm._s(_vm.attention.creator.name) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _vm.attention.status !== "PENDING" && _vm.attention.finishedBy
          ? _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
              _vm.attention.finishedBy
                ? _c("div", [
                    _vm.attention.finishedBy
                      ? _c(
                          "span",
                          { staticClass: "meta-item finish-reponsible" },
                          [
                            _vm._v(
                              "Responsable: " +
                                _vm._s(_vm.attention.finishedBy.name)
                            )
                          ]
                        )
                      : _c(
                          "span",
                          { staticClass: "meta-item finish-reponsible" },
                          [_vm._v("Sin responsable de cierre")]
                        )
                  ])
                : _vm._e()
            ])
          : _c("div", { staticStyle: { "margin-bottom": "10px" } }),
        _vm._v(" "),
        !_vm.attention.isDone
          ? _c("div", { staticClass: "actions" }, [
              _c(
                "a",
                {
                  staticClass: "button is-primary",
                  staticStyle: {
                    "margin-bottom": "10px",
                    "text-decoration": "none"
                  },
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.finishAttention(_vm.attention.id)
                    }
                  }
                },
                [_vm._v("Finalizar")]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }